import * as SlotFamilyTypes from '../../../constants/SlotFamilyType';
import SingleLineOutcome from './slots/SingleLineSlots';
import TwoColumnSlot from './slots/TwoColumnSlot';
import FourColumnSlot from './slots/FourColumnSlot';
import RegularOutcome from './slots/RegularSlots';
import TotalSlots from './slots/TotalSlots';
import EuropeanHandicapSlot from './slots/EuropeanHandicapSlot';
import CorrectScoreSlot from './slots/CorrectScoreSlot';
import MatchResultSlot from './slots/MatchResultSlot';
import TennisGameWinnerSlot from './slots/TennisGameWinnerSlot';
import WhoHigherSlot from './slots/WhoHigherSlot';
export default function (slotFamily) {
    switch (slotFamily) {
        case SlotFamilyTypes.MORE_THAN_X_GOALS:
        case SlotFamilyTypes.CONDITIONAL_THREE_WAY:
        case SlotFamilyTypes.TOTAL_AND_BOTH_TO_SCORE:
            return SingleLineOutcome;
        case SlotFamilyTypes.HANDICAP:
        case SlotFamilyTypes.TOTAL:
            return TotalSlots;
        case SlotFamilyTypes.EUROPEAN_HANDICAP:
            return EuropeanHandicapSlot;
        case SlotFamilyTypes.CORRECT_SCORE:
            return CorrectScoreSlot;
        case SlotFamilyTypes.FIRST_GOAL_MINUTES:
        case SlotFamilyTypes.TWO_WAY:
        case SlotFamilyTypes.FOUR_WAY:
        case SlotFamilyTypes.ASIAN_HANDICAP:
            return TwoColumnSlot;
        case SlotFamilyTypes.MINIMATCH_TOTAL:
        case SlotFamilyTypes.MATCH_HANDICAP:
        case SlotFamilyTypes.MATCH_RESULTS_MINUTES:
            return MatchResultSlot;
        case SlotFamilyTypes.FOUR_COLUMN:
            return FourColumnSlot;
        case SlotFamilyTypes.TENNIS_GAME_WINNER:
            return TennisGameWinnerSlot;
        case SlotFamilyTypes.WHO_HIGHER:
            return WhoHigherSlot;
        default:
            return RegularOutcome;
    }
}



// WEBPACK FOOTER //
// ./src/components/grid/event/slotComponentFactory.js